import {Center, Icon, Button, Image, Box, Textarea} from '@chakra-ui/react'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import {ReactComponent as ArrowRightIcon} from '@assets/svgs/arrow_right.svg'
import GlobalMic3 from '@components/GlobalMic3'
import {CommonColors} from '@utils/CommonStyles'
import TypeSquareImage from '@assets/images/type-square.png'
import {useEffect, useRef, useState} from 'react'
import {ReactComponent as MicOutlineIcon} from '@assets/svgs/mic_outline.svg'
import learnPartTwoRequest from '@apis/learn-part-two'
import {useDispatch, useSelector} from 'react-redux'
import {
  updateMessages,
  updateCurrentPhaseIndex,
  updateIsLoadingBot,
  updateIsFinish,
  updateAudioFileUser,
  updateAudio,
  reset,
} from '@redux/learn-part-two/learnPartTwo'
import {useLocation, useNavigate} from 'react-router-dom'
import {PATH} from '@utils/Const'
import learnRequest from '@apis/learn'
import {audioRef} from '@utils'
import {ReactComponent as CupIcon} from '@assets/svgs/cup.svg'

const Footer = ({
  data,
  sessionId,
  isShowFooter,
  currentContent,
  setCurrentContentIndex,
}: {
  data: any
  sessionId: string
  isShowFooter: boolean
  currentContent: any
  setCurrentContentIndex: any
}) => {
  const {
    messages,
    currentPhaseIndex,
    userIdeaHistoryId,
    isLoadingBot,
    isFinish,
    userIdea,
    audio,
  } = useSelector((state: any) => state.learnPartTwo)
  const {entry_point, task_id} = useLocation()?.state || {}
  const [textInput, setTextInput] = useState('')
  const [isManualInput, setIsManualInput] = useState(false)
  const [isLoadingMic, setIsLoadingMic] = useState(false)
  const [isMicRecording, setIsMicRecording] = useState(false)
  const [isDoneCheckAnswer, setIsDoneCheckAnswer] = useState(false)
  const [isPracticeSpeak, setIsPracticeSpeak] = useState(false)
  const [currentAudioFile, setCurrentAudioFile] = useState<any>(null)
  const [isFirstMsg, setIsFirstMsg] = useState(true)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const micRef = useRef<any>(null)

  useEffect(() => {
    if (!currentContent) return
    let audioData = {
      time: Date.now(),
      url: '',
    }

    switch (currentContent?.type) {
      case 'LESSON_OVERVIEW':
      case 'IDEA_FRAME':
      case 'USER_IDEA':
      case 'FINAL_IDEA_FRAME':
        audioData.url = currentContent?.introduction_audio
        break
      default:
        break
    }

    dispatch(updateAudio(audioData))
  }, [currentContent])

  useEffect(() => {
    if (!audio?.url) return

    let isSubscribed = true // Track if component is mounted

    const playAudio = async () => {
      try {
        if (!isSubscribed) return // Don't play if unmounted

        // Reset audio state
        audioRef.current.pause()
        audioRef.current.currentTime = 0

        audioRef.current.src = audio?.url
        // Wait for audio to load before playing
        await audioRef.current.load()

        if (isSubscribed) {
          // Check again before playing
          await audioRef.current.play()
        }
      } catch (error) {
        console.error('Error playing audio:', error)
      }
    }

    playAudio()

    return () => {
      isSubscribed = false // Cleanup flag
      if (audioRef.current) {
        audioRef.current.pause()
        audioRef.current.src = '' // Clear source
      }
    }
  }, [audio])

  const handleClickContinue = () => {
    setCurrentContentIndex((prev: any) => prev + 1)

    if (audioRef.current) {
      audioRef.current.pause()
    }

    if (currentContent?.type === 'USER_IDEA') return
    const params = {
      session_id: sessionId,
      step: currentContent?.step,
    }

    learnPartTwoRequest.saveStep(params)
  }

  const handleClickPracticeContinue = () => {
    if (audioRef.current) {
      audioRef.current.pause()
    }

    if (isFinish) {
      dispatch(reset())
      if (entry_point === 'ROADMAP') {
        navigate(PATH.ROADMAP_SUMMARY, {
          state: {
            task_id,
          },
        })
      } else {
        navigate(-1)
      }
      return
    }

    if (currentContent?.type === 'SUMMARY' && !isFinish) {
      micRef.current?.handleStopRecording()
      handleGetScore()
      return
    }

    micRef.current?.handleStopRecording()
    setIsDoneCheckAnswer(false)
    setIsPracticeSpeak(false)
    dispatch(updateAudioFileUser(null))

    if (currentPhaseIndex === userIdea?.length - 1) {
      setCurrentContentIndex((prev: any) => prev + 1)

      if (audioRef.current) {
        audioRef.current.pause()
      }

      dispatch(updateMessages([]))

      const params = {
        session_id: sessionId,
        step: currentContent?.step,
      }

      learnPartTwoRequest.saveStep(params)
      return
    }

    dispatch(updateCurrentPhaseIndex(currentPhaseIndex + 1))
  }

  const handleSendText = async () => {
    let message = {
      content: textInput.trim(),
      type: 'USER',
    }

    setIsManualInput(false)
    dispatch(updateMessages([...messages, message]))
    let content = ''

    let audioData = {
      time: Date.now(),
      url: '',
    }

    if (currentContent?.type === 'SUMMARY') {
      dispatch(updateIsLoadingBot(true))

      if (isFirstMsg) {
        content = currentContent?.data?.summary_intro?.text
        audioData.url = currentContent?.data?.summary_intro?.audio
        setIsFirstMsg(false)
      } else {
        const formData = new FormData()
        formData.append('audio-file', currentAudioFile)
        formData.append('text-refs', textInput)
        const res = await learnRequest.getSpeechCheck(formData)
        const number = Math.floor(Math.random() * 3)

        if (res?.data?.data?.total_score * 100 < 50) {
          content = data?.pronounce_response?.bad_score[number]?.text
          audioData.url = data?.pronounce_response?.bad_score[number]?.audio
        } else {
          content = data?.pronounce_response?.good_score[number]?.text
          audioData.url = data?.pronounce_response?.good_score[number]?.audio
        }
      }

      const message2 = {
        type: 'BOT',
        content: content,
      }

      setTimeout(() => {
        dispatch(updateMessages([...messages, message, message2]))
        setIsDoneCheckAnswer(true)
        dispatch(updateIsLoadingBot(false))
        dispatch(updateAudio(audioData))
      }, 1000)
      return
    } else {
      setTextInput('')
    }

    if (isPracticeSpeak) {
      dispatch(updateIsLoadingBot(true))
      setIsPracticeSpeak(false)
      const formData = new FormData()
      formData.append('audio-file', currentAudioFile)
      formData.append('text-refs', textInput)
      const res = await learnRequest.getSpeechCheck(formData)
      const number = Math.floor(Math.random() * 3)
      let content = ''

      if (res?.data?.data?.total_score * 100 < 50) {
        content = data?.pronounce_response?.bad_score[number]?.text
        audioData.url = data?.pronounce_response?.bad_score[number]?.audio
      } else {
        content = data?.pronounce_response?.good_score[number]?.text
        audioData.url = data?.pronounce_response?.good_score[number]?.audio
      }

      const message2 = {
        type: 'BOT',
        content: content,
      }

      setTimeout(() => {
        dispatch(updateMessages([...messages, message, message2]))
        dispatch(updateIsLoadingBot(false))
        dispatch(updateAudio(audioData))
      }, 1000)

      return
    }

    const newMessages = [...messages, message]
    const formData = new FormData()
    formData.append('user-idea-history-id', userIdeaHistoryId)
    formData.append('user-answer', textInput)

    if (currentAudioFile) {
      formData.append('audio-file', currentAudioFile)
    }

    const params = {
      session_id: sessionId,
      form_data: formData,
    }

    dispatch(updateIsLoadingBot(true))
    const number = Math.floor(Math.random() * 3)
    content = currentContent?.data?.idea_practice_response_intro[number]?.text
    audioData.url =
      currentContent?.data?.idea_practice_response_intro[number]?.audio
    dispatch(updateAudio(audioData))

    const newMessage1 = {
      type: 'BOT',
      content: content,
    }

    dispatch(updateMessages([...newMessages, newMessage1]))

    const res = await learnPartTwoRequest.checkAnswers(params)

    const newMessage2 = {
      type: 'SUGGESTION',
      data: res?.data?.data,
    }

    dispatch(updateIsLoadingBot(false))
    dispatch(updateMessages([...newMessages, newMessage1, newMessage2]))
    setIsDoneCheckAnswer(true)
  }

  const handleGetScore = async () => {
    dispatch(updateIsLoadingBot(true))
    const formData = new FormData()
    formData.append('user_answer', textInput)
    formData.append('audio-file', currentAudioFile)

    const params = {
      session_id: sessionId,
      form_data: formData,
    }

    const res = await learnPartTwoRequest.getScore(params)
    dispatch(updateIsFinish(true))

    const scoreMsg = {
      type: 'SCORE',
      ...res?.data?.data?.score_message,
    }

    const summaryMsg = {
      type: 'SUMMARY',
      ...res?.data?.data?.session_summary_message,
    }

    dispatch(updateMessages([...messages, scoreMsg, summaryMsg]))
    dispatch(updateIsLoadingBot(false))
  }

  const handleStartRecording = () => {
    if (audioRef.current) {
      audioRef.current.pause()
    }
    setIsMicRecording(true)
  }

  const handleRecordingComplete = async (recordingBlob: Blob) => {
    setIsLoadingMic(true)

    try {
      let file = new File([recordingBlob], 'audio.wav', {type: 'audio/wav'})
      setCurrentAudioFile(file)
      dispatch(updateAudioFileUser(file))
      const formData = new FormData()
      formData.append('session-id', '')
      formData.append('audio-file', file)
      const res = await learnPartTwoRequest.stt(formData)
      setTextInput(res?.data?.data?.text || '')
    } catch (error) {
    } finally {
      setIsManualInput(true)
      setIsLoadingMic(false)
      setIsMicRecording(false)
    }
  }

  return (
    <>
      {currentContent?.type === 'IDEA_PRACTICE' && (
        <>
          {isManualInput ? (
            <Center
              height={'100px'}
              maxWidth={'900px'}
              w={'100%'}
              mx={'auto'}
              gap={'20px'}
              alignItems={'center'}
              justifyContent={'center'}>
              <Center
                cursor={'pointer'}
                bg={CommonColors.primary}
                w={'48px'}
                h={'48px'}
                flexShrink={0}
                borderRadius={'8px'}
                onClick={() => setIsManualInput(false)}>
                <Icon
                  as={MicOutlineIcon}
                  width={'24px'}
                  height={'24px'}
                  sx={{
                    path: {
                      stroke: 'white',
                    },
                  }}
                />
              </Center>
              <Textarea
                value={textInput}
                h={'48px'}
                rows={1}
                resize="vertical"
                onChange={e => setTextInput(e.target.value)}
              />
              <Button
                isDisabled={!textInput}
                color={CommonColors.primary}
                onClick={handleSendText}>
                Gửi
              </Button>
            </Center>
          ) : (
            <Center height={'100px'} gap={'30px'}>
              {isDoneCheckAnswer && (
                <Box
                  width={
                    currentPhaseIndex === userIdea?.length - 1
                      ? '143px'
                      : '186px'
                  }
                />
              )}
              {!isDoneCheckAnswer && (
                <Button
                  isDisabled={isLoadingMic || isLoadingBot}
                  gap={'4px'}
                  alignItems={'center'}
                  variant={'outline'}
                  color={CommonColors.primary}
                  borderColor={CommonColors.primary}
                  borderRadius={'100px'}
                  onClick={() => setIsManualInput(true)}>
                  <Image src={TypeSquareImage} width={'16px'} height={'16px'} />
                  Nhập tay
                </Button>
              )}
              {(isDoneCheckAnswer && isPracticeSpeak) || !isDoneCheckAnswer ? (
                <GlobalMic3
                  ref={micRef}
                  isDisabled={isLoadingBot}
                  isLoading={isLoadingMic}
                  handleStartRecording={handleStartRecording}
                  handleRecordingComplete={handleRecordingComplete}
                />
              ) : (
                <Button
                  isDisabled={isLoadingBot}
                  gap={'4px'}
                  alignItems={'center'}
                  variant={'outline'}
                  color={CommonColors.primary}
                  borderColor={CommonColors.primary}
                  onClick={() => {
                    setIsPracticeSpeak(true)
                    setTimeout(() => {
                      micRef.current?.handleClickMic()
                    }, 100)
                  }}>
                  <Icon as={MicOutlineIcon} width={'16px'} height={'16px'} />
                  Luyện nói
                </Button>
              )}

              {isDoneCheckAnswer ? (
                <GlobalButton
                  gap={2}
                  isDisabled={isLoadingMic || isLoadingBot || isMicRecording}
                  onClick={handleClickPracticeContinue}>
                  {currentPhaseIndex === userIdea?.length - 1
                    ? 'Hoàn thiện'
                    : 'Luyện ý tiếp theo'}
                  <Icon
                    as={ArrowRightIcon}
                    sx={{
                      width: '16px',
                      height: '16px',
                      path: {
                        stroke: 'white',
                      },
                    }}
                  />
                </GlobalButton>
              ) : (
                <Box width={'122px'} />
              )}
            </Center>
          )}
        </>
      )}
      {currentContent?.type === 'SUMMARY' && (
        <>
          {isManualInput ? (
            <Center
              height={'100px'}
              maxWidth={'900px'}
              w={'100%'}
              mx={'auto'}
              gap={'20px'}
              alignItems={'center'}
              justifyContent={'center'}>
              <Center
                cursor={'pointer'}
                bg={CommonColors.primary}
                w={'48px'}
                h={'48px'}
                flexShrink={0}
                borderRadius={'8px'}
                onClick={() => setIsManualInput(false)}>
                <Icon
                  as={MicOutlineIcon}
                  width={'24px'}
                  height={'24px'}
                  sx={{
                    path: {
                      stroke: 'white',
                    },
                  }}
                />
              </Center>
              <Textarea
                value={textInput}
                h={'48px'}
                rows={1}
                resize="vertical"
                onChange={e => setTextInput(e.target.value)}
              />
              <Button
                isDisabled={!textInput}
                color={CommonColors.primary}
                onClick={handleSendText}>
                Gửi
              </Button>
            </Center>
          ) : (
            <Center height={'100px'} gap={'30px'}>
              {isDoneCheckAnswer && !isFinish && <Box width={'140px'} />}
              {!isFinish && (
                <>
                  {(isDoneCheckAnswer && isPracticeSpeak) ||
                  !isDoneCheckAnswer ? (
                    <GlobalMic3
                      ref={micRef}
                      isDisabled={isLoadingBot}
                      isLoading={isLoadingMic}
                      handleStartRecording={handleStartRecording}
                      handleRecordingComplete={handleRecordingComplete}
                    />
                  ) : (
                    <Button
                      isDisabled={isLoadingBot}
                      gap={'4px'}
                      alignItems={'center'}
                      variant={'outline'}
                      color={CommonColors.primary}
                      borderColor={CommonColors.primary}
                      onClick={() => {
                        setIsPracticeSpeak(true)
                        setTimeout(() => {
                          micRef.current?.handleClickMic()
                        }, 100)
                      }}>
                      <Icon
                        as={MicOutlineIcon}
                        width={'16px'}
                        height={'16px'}
                      />
                      Luyện nói
                    </Button>
                  )}
                </>
              )}
              {isDoneCheckAnswer && (
                <GlobalButton
                  gap={2}
                  isDisabled={isLoadingMic || isLoadingBot || isMicRecording}
                  onClick={handleClickPracticeContinue}>
                  {isFinish ? 'Hoàn thành' : 'Hoàn Thiện'}
                  <Icon
                    as={isFinish ? CupIcon : ArrowRightIcon}
                    sx={{
                      width: '16px',
                      height: '16px',
                      path: {
                        stroke: 'white',
                      },
                    }}
                  />
                </GlobalButton>
              )}
            </Center>
          )}
        </>
      )}
      {(currentContent?.type === 'LESSON_OVERVIEW' ||
        currentContent?.type === 'IDEA_FRAME' ||
        currentContent?.type === 'FINAL_IDEA_FRAME' ||
        currentContent?.type === 'USER_IDEA') && (
        <Center height={'100px'}>
          {isShowFooter && (
            <GlobalButton gap={2} onClick={handleClickContinue}>
              {currentContent?.type === 'FINAL_IDEA_FRAME'
                ? 'Bắt đầu luyện nói'
                : 'Tiếp tục'}
              <Icon
                as={ArrowRightIcon}
                sx={{
                  width: '16px',
                  height: '16px',
                  path: {
                    stroke: 'white',
                  },
                }}
              />
            </GlobalButton>
          )}
        </Center>
      )}
      <audio ref={audioRef} onEnded={() => {}} style={{display: 'none'}}>
        Trình duyệt của bạn không hỗ trợ thẻ audio.
      </audio>
    </>
  )
}

export default Footer
